module.exports = __webpack_public_path__ + "img/function_img6_fan.a1fb1d7a.png";